module.exports = __webpack_public_path__ + "img/2.dcdca7f8.png";